var AssetDirectory = {
	"preloader": [
		"assets/font/preloader/exo-bold.ttf",
		"assets/font/preloader/exo-medium.ttf",
		"assets/font/preloader/proximanova-black.ttf",
		"assets/images/preloader/loader/gfx_bg.png",
		"assets/images/preloader/loader/gfx_loading.png",
		"assets/images/preloader/loader/gizmoloading.json",
		"assets/images/preloader/loader/gizmoloading_ske.json",
		"assets/images/preloader/loader/gizmoloading_tex.json",
		"assets/images/preloader/loader/gizmoloading_tex.png",
		"assets/sounds/preloader/loader/bgm/game_bgm.ogg",
		"assets/sounds/preloader/loader/sfx/button_sfx.ogg",
		"assets/sounds/preloader/loader/sfx/score_points.ogg",
		"assets/sounds/preloader/loader/sfx/star_gain.ogg",
		"assets/strings/preloader/strings.json"
	],
	"undefined": [
		"assets/.DS_Store",
		"assets/images/.DS_Store"
	],
	".DS_Store": [
		"assets/images/external/.DS_Store"
	],
	"game": [
		"assets/images/external/game/bg_serpent.png",
		"assets/images/external/game/brownb_idle01.png",
		"assets/images/external/game/brownb_idle02.png",
		"assets/images/external/game/dove_idle01.png",
		"assets/images/external/game/dove_idle02.png",
		"assets/images/external/game/fx_firsttimeplay_glow.png",
		"assets/images/external/game/fx_warning.png",
		"assets/images/external/game/leaf/fx_leaf_ske.json",
		"assets/images/external/game/leaf/fx_leaf_tex.json",
		"assets/images/external/game/leaf/fx_leaf_tex.png",
		"assets/images/external/game/monkey_idle01.png",
		"assets/images/external/game/monkey_idle02.png",
		"assets/images/external/game/raven_idle01.png",
		"assets/images/external/game/raven_idle02.png",
		"assets/images/external/game/serpent_tree.png",
		"assets/images/external/game/sloth_idle01.png",
		"assets/images/external/game/sloth_idle02.png",
		"assets/images/external/game/snake_hit01.png",
		"assets/images/external/game/snake_hit02.png",
		"assets/images/external/game/snake_hit03.png",
		"assets/images/external/game/snake_idle01.png",
		"assets/images/external/game/snake_idle02.png",
		"assets/images/external/game/snake_idle03.png",
		"assets/images/external/game/tap/fx_hit_ske.json",
		"assets/images/external/game/tap/fx_hit_tex.json",
		"assets/images/external/game/tap/fx_hit_tex.png",
		"assets/images/external/game/toucan_idle01.png",
		"assets/images/external/game/toucan_idle02.png",
		"assets/sounds/external/game/animal_spawn.ogg",
		"assets/sounds/external/game/jungle_ambience.ogg",
		"assets/sounds/external/game/select_serpent.ogg",
		"assets/sounds/external/game/select_wrong_animal.ogg",
		"assets/sounds/external/game/serpent_caught.ogg"
	],
	"title": [
		"assets/images/external/title/bg_logo_serpent.png",
		"assets/images/external/title/logo_serpent.png"
	],
	"ui": [
		"assets/images/external/ui/btn_audio1.png",
		"assets/images/external/ui/btn_audio2.png",
		"assets/images/external/ui/btn_audio3.png",
		"assets/images/external/ui/btn_audio4.png",
		"assets/images/external/ui/btn_close.png",
		"assets/images/external/ui/btn_exit.png",
		"assets/images/external/ui/btn_exit2.png",
		"assets/images/external/ui/btn_pause.png",
		"assets/images/external/ui/btn_pause2.png",
		"assets/images/external/ui/btn_play.png",
		"assets/images/external/ui/btn_play2.png",
		"assets/images/external/ui/btn_prevnext.png",
		"assets/images/external/ui/btn_prevnext2.png",
		"assets/images/external/ui/btn_replay.png",
		"assets/images/external/ui/btn_replay2.png",
		"assets/images/external/ui/btn_return.png",
		"assets/images/external/ui/btn_return2.png",
		"assets/images/external/ui/check-button1.png",
		"assets/images/external/ui/check-button2.png",
		"assets/images/external/ui/gfx_container.png",
		"assets/images/external/ui/gfx_container_white.png",
		"assets/images/external/ui/gfx_explode.png",
		"assets/images/external/ui/gfx_flare_long.png",
		"assets/images/external/ui/gfx_flare_star.png",
		"assets/images/external/ui/gfx_loading_bar_con.png",
		"assets/images/external/ui/gfx_pop.png",
		"assets/images/external/ui/gfx_pop2.png",
		"assets/images/external/ui/gfx_star0.png",
		"assets/images/external/ui/gfx_star1.png",
		"assets/images/external/ui/gfx_starbg.png",
		"assets/images/external/ui/htp_serpent1.png",
		"assets/images/external/ui/htp_serpent2.png",
		"assets/images/external/ui/htp_serpent3.png",
		"assets/images/external/ui/htp_serpent4.png",
		"assets/images/external/ui/htp_serpent5.png",
		"assets/images/external/ui/x-button1.png",
		"assets/images/external/ui/x-button2.png"
	]
};